import { useContext, useEffect } from 'react';

import { FormGroupContext, type Event } from '@/components/FormGroup';

export const useFormGroupListener = (name: string, callback: (event: Event) => Promise<any>) => {
  const groupContext = useContext(FormGroupContext);

  useEffect(() => {
    if (!groupContext) {
      return;
    }

    groupContext.register(name, callback);

    return () => {
      groupContext.unregister(name);
    };
  }, [groupContext, name, callback]);
};
